var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"p-5"},[_c('b-row',{staticClass:"h-25",attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"text-center h2",attrs:{"lg":"12"}},[_vm._v("4GBox OTA Platform")])],1),_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"lg":"4","offset-lg":"4"}},[_c('LoginForm')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }